import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RoleGuard } from "@/components/auth/RoleGuard";
import {
  LayoutDashboard,
  Mail,
  BookOpen,
  Users,
  GraduationCap,
  MessageSquare,
  FileText,
  Calendar,
  Image as ImageIcon,
  Layers,
  ListChecks,
  Award,
  Link2,
  BookText,
} from "lucide-react";
import { DashboardLayout } from "@/components/layouts/DashboardLayout";

export const Route = createFileRoute("/_authenticated/admin")({
  head: () => ({ meta: [{ title: "Admin — Code Cubs Academy" }] }),
  component: AdminLayout,
});

const navItems = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, exact: true },
  { to: "/admin/contacts", label: "Contacts", icon: Mail },
  { to: "/admin/enrollments", label: "Enrollments", icon: GraduationCap },
  { to: "/admin/courses", label: "Courses", icon: BookOpen },
  { to: "/admin/lessons", label: "Lessons", icon: BookText },
  { to: "/admin/quizzes", label: "Quizzes", icon: ListChecks },
  { to: "/admin/badges", label: "Badges", icon: Award },
  { to: "/admin/groups", label: "Groups", icon: Layers },
  { to: "/admin/links", label: "Links", icon: Link2 },
  { to: "/admin/testimonials", label: "Testimonials", icon: MessageSquare },
  { to: "/admin/blog", label: "Blog", icon: FileText },
  { to: "/admin/events", label: "Events", icon: Calendar },
  { to: "/admin/projects", label: "Projects", icon: ImageIcon },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/logs", label: "Activity Logs", icon: LayoutDashboard },
  { to: "/admin/learning-paths", label: "Learning Paths", icon: Award },
  { to: "/admin/settings", label: "Site Settings", icon: LayoutDashboard },
];

function AdminLayout() {
  return (
    <RoleGuard allowedRoles={["admin"]}>
      <DashboardLayout title="Admin Panel" navItems={navItems}>
        <Outlet />
      </DashboardLayout>
    </RoleGuard>
  );
}
